import { getFontFamilies } from '@wix/thunderbolt-becky-root'
import type { Component, VariablesValues, VariablesVar } from '@wix/thunderbolt-becky-types'
import { Font, type FontValue } from '@wix/css-property-parser'
import type { VariantRelationViewItem } from '@wix/thunderbolt-catharsis'
import { createCompNode, themeRefs } from '@wix/thunderbolt-catharsis'
import { EMPTY_ARRAY } from '../../../utils/constants'
import type { FeatureRefs } from '../../cssFeatures.types'

export const masterPageThemeFontFamilies = {
	predicate: (component: Component) => component.type === 'Document',
	compNode: createCompNode({
		getDependencies: () => themeRefs.themeFonts,
		toViewItem: (__, themeFontsMap) =>
			themeFontsMap ? Object.values(themeFontsMap).flatMap(getFontFamilies) : EMPTY_ARRAY,
	}),
}

const extractFontFamiliesFromVariables = (variablesList: Array<VariablesValues | VariantRelationViewItem<VariablesValues>>) => {
	const fontFamilies: Array<string> = []

	variablesList.forEach((variable) => {
		const variableValue = variable?.type === 'VariantRelation' ? variable.to?.value : variable?.value
		const parsedFont: FontValue | null = variableValue ? Font.parse(variableValue as string) : null

		if (parsedFont && 'fontFamily' in parsedFont && parsedFont.fontFamily) {
			if (parsedFont.fontFamily.type === 'font-list') {
				// push all the font families
				parsedFont.fontFamily?.families?.forEach((family: string) => {
					fontFamilies.push(family)
				})
			}
		}
	})

	return fontFamilies
}

export const masterPageVariablesFontFamilies = {
	predicate: (component: Component) => component.type === 'Document',
	compNode: createCompNode({
		getDependencies: (component: Component, refs: FeatureRefs<'variables'>) =>
			component.variablesQuery ? refs.variablesQuery(component.variablesQuery) : null,
		toViewItem: (__, variablesList) => {
			if (!variablesList || !variablesList.variables) {
				return EMPTY_ARRAY
			}

			const variables = variablesList.variables as Array<VariablesVar>
			const variablesRefArray = variables.flatMap((v) => {
				if (v.type === 'FontVar') {
					// Cast the values to match the expected type
					return v.value.values as Array<VariablesValues | VariantRelationViewItem<VariablesValues>>
				}
				return []
			})

			return extractFontFamiliesFromVariables(variablesRefArray)
		},
	}),
}
